import React from "react";
import { Marker as MapGLMarker, Popup } from "react-map-gl";

import { Typography } from "@material-ui/core";
import FiberManualRecordRoundedIcon from "@material-ui/icons/FiberManualRecordRounded";
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';

import SimpleTooltip, { SimpleTooltipBackgroundColour, SimpleTooltipPlacement } from "components/SimpleTooltip";
import useColourPalette from "components/visuals/useColourPalette";

import { Competitor } from "modules/customer/tools/product/productStoreFit/competitor";

interface MarkerProps {
    competitor: Competitor,
    onTooltipOpen: () => void,
    onTooltipClose: () => void,
    labelVisible: boolean
}

const Marker: React.FC<MarkerProps> = (props) => {
    const { competitor, onTooltipOpen, onTooltipClose, labelVisible } = props;
    const colourPalette = useColourPalette();
    const [showLabel, setShowLabel] = React.useState(false);

    const handleOpen = () => {
        onTooltipOpen();
        setShowLabel(true);
    };

    const handleClose = () => {
        onTooltipClose();
        setShowLabel(false);
    };

    return (
        <>
            <MapGLMarker
                latitude={competitor.latitude}
                longitude={competitor.longitude}
                offsetTop={-10}
                offsetLeft={-10}
            >
                <SimpleTooltip
                    placement={SimpleTooltipPlacement.Bottom}
                    backgroundColour={SimpleTooltipBackgroundColour.Quaternary}
                    open={false}
                    onOpen={handleOpen}
                    onClose={handleClose}
                    title={
                        <Typography variant="body2" component="div" align="center" style={{ fontWeight: "bold" }}>
                            {competitor.fascia}
                        </Typography>
                    }
                >
                    {competitor.directCompetitor ? (
                        <PlayArrowRoundedIcon fontSize="small" cursor="pointer" style={{ color: colourPalette.categorical[2], transform: "rotate(90deg)" }} />
                    ) : (
                        <FiberManualRecordRoundedIcon fontSize="small" cursor="pointer" style={{ color: colourPalette.categorical[0] }} />
                    )}
                </SimpleTooltip>
            </MapGLMarker>
            {(labelVisible || showLabel) && <Popup
                anchor="top"
                longitude={competitor.longitude}
                latitude={competitor.latitude}
                closeButton={false}
                offsetTop={10}
                className={"mapboxgl-popup-zindex-1"}
            >
                <Typography variant="body2" component="div" align="center" style={{ fontWeight: "bold" }}>
                    {competitor.fascia}
                </Typography>
            </Popup>}
        </>
    );
};

export default Marker;
